<template>
  <div
    v-if="viewport == 'sm'"
    class="d-flex"
  >
    <span>Notifications</span>

    <i
      data-test-id="notification_count_indicator"
      class="fa fa-sm"
      :class="{
        'fa-spin fa-spinner text-white': loadingNotifications,
        'fa-circle text-danger': !loadingNotifications && hasUnread,
      }"
      style="margin-top: 8px; margin-left: 3px"
    />
  </div>
  <div
    v-else
    class="position-relative"
  >
    <i class="fa fa-bell" />

    <i
      class="fa fa-sm"
      :class="[
        { 'fa-spin fa-spinner text-white': loadingNotifications },
        { 'fa-circle text-danger': !loadingNotifications && hasUnread },
        'position-absolute',
      ]"
      style="top: 5px; right: -5px"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Notifications",

  props: {
    viewport: {
      type: String,
      default: "lg",
    },
  },

  computed: {
    ...mapGetters([
      "hasUnreadNotifications",
      "hasUnreadAnnouncements",
      "loadingNotifications",
    ]),

    hasUnread() {
      return this.hasUnreadNotifications || this.hasUnreadAnnouncements;
    },
  },
};
</script>
